import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useLazyFetchUserProfileQuery } from 'src/store/userApi';
import { Spinner } from 'src/ui/Spinner';
import ConversationList from '../conversation-history/conversationList';
import MessageView from '../conversation-history/messageView';
import { UserConversationEntity } from 'src/store/chatApi';

interface UserConversationHistoryProps {
  userId: string | null;
}

const UserConversationHistory = ({ userId }: UserConversationHistoryProps) => {
  const [selectedConversation, setSelectedConversation] =
    useState<UserConversationEntity | null>(null);
  const [searchParams] = useSearchParams();
  const userConversationId = searchParams.get('userConversationId');
  const [fetchUserProfile, { data: userProfile, isLoading }] =
    useLazyFetchUserProfileQuery();

  useEffect(() => {
    if (userId) {
      fetchUserProfile(userId);
    }
  }, [userId, fetchUserProfile]);

  const handleSelectConversation = (conversation: UserConversationEntity) => {
    setSelectedConversation(conversation);
  };

  if (!userId) {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%',
        }}
      >
        <span style={{ color: 'var(--text-muted)', fontSize: 'var(--fs-lg)' }}>
          Select a user to view their conversation history
        </span>
      </div>
    );
  }

  if (isLoading) {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%',
        }}
      >
        <Spinner size="lg" />
      </div>
    );
  }

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: '400px 1fr',
        height: '100%',
        overflow: 'hidden',
      }}
    >
      {/* Left Column - Conversation List */}
      <div
        style={{
          borderRight: '1px solid var(--border)',
          height: '100%',
          overflowY: 'auto',
          padding: 16,
        }}
      >
        <ConversationList
          selectedUser={userProfile || null}
          selectedConversation={selectedConversation}
          onSelectConversation={handleSelectConversation}
          preSelectConversationId={userConversationId}
        />
      </div>

      {/* Right Column - Message View */}
      <div style={{ height: '100%', overflow: 'hidden' }}>
        <MessageView
          selectedUser={userProfile || null}
          selectedConversation={selectedConversation}
        />
      </div>
    </div>
  );
};

export default UserConversationHistory;
